"use strict";

import angular from "angular";

import _ from "lodash";

angular.module("nucont.accounting.company.parameterizationOnDemand").config(["$stateProvider", routeConfig]);

function routeConfig($stateProvider) {
    $stateProvider.state("nucont.accounting.company.parameterizationOnDemand", {
        url: "/parametrizacao-por-demanda/:date",
        lazyLoad(transition) {
            const $ocLazyLoad = transition.injector().get("$ocLazyLoad");
            return import(
                /* webpackChunkName: "feature-accounting-company-parameterization-on-demand" */ "./parameterization-on-demand.entry"
            ).then(() =>
                $ocLazyLoad.inject("nucont.accounting.company.parameterizationOnDemand")
            );
        },
        params: {
            date: { value: null, dynamic: true },
            openParameterize: { value: null },
            withoutParameterizationOnDemand: { value: null }
        },
        views: {
            "admin@nucont.accounting": {
                component: "parameterizationOnDemandComponent",
                bindings: { companyData: "CompanyData" }
            }
        },
        bodyClass: "parameterization-module"
    });
}
